/**
 * Single source of truth for the admin tab bar.
 *
 * Both the admin route and the docs coverage check import this list, so adding
 * a tab here immediately surfaces a "docs missing" warning in the Help tab (and
 * fails the admin-docs coverage test) until it is documented in
 * `src/lib/admin-docs.ts`.
 */

export const ADMIN_TAB_DEFS = [
  { id: "overview", label: "Overview" },
  { id: "pages", label: "Pages" },
  { id: "navigation", label: "Navigation" },
  
  { id: "appearance", label: "Appearance" },
  { id: "media", label: "Media" },
  { id: "settings", label: "Site" },
  { id: "products", label: "Products" },
  { id: "packaging", label: "Packaging" },
  { id: "tracking", label: "Tracking" },
  { id: "amazon", label: "Amazon" },
  { id: "ab_tests", label: "Amazon A/B" },
  { id: "experiments", label: "Experiments" },
  { id: "marketing", label: "Marketing" },
  { id: "orders", label: "Orders" },
  { id: "leads", label: "Leads" },
  { id: "users", label: "Users" },
  { id: "analytics_qa", label: "Analytics QA" },
  { id: "help", label: "Help" },
] as const;

export type AdminTab = (typeof ADMIN_TAB_DEFS)[number]["id"];

export const ADMIN_TABS: AdminTab[] = ADMIN_TAB_DEFS.map((t) => t.id);

export function adminTabLabel(id: string): string {
  return ADMIN_TAB_DEFS.find((t) => t.id === id)?.label ?? id;
}
